import React from 'react';
import _ from 'lodash';
import Error from './../../src/images/img-error@2x.png';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, eventId: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
  }

  render() {
    if (this.state.error) {
      //render fallback UI
      return (
        <article className='error'>
          <div className='error__body'>
            <div className='error__title'>エラーが発生しました</div>

            <div className='error__image'>
              <img src={Error} alt='エラーが発生しました' />
            </div>

            <p className='error__message'>
              大変申し訳ございません。指定されたページでエラーが発生しました。
            </p>

            <div className='error__button'>
              <a
                href='/login'
                className='btn--sub'
                style={{ pointerEvents: 'all' }}
              >
                戻る
              </a>
            </div>
          </div>
        </article>
      );
    }

    //when there's not an error, render children untouched
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.jsx